<template>
  <v-card v-if="person">
    <v-card-title>
      {{ person.full_code }}
      <template v-if="person && person.customergroups">
        <v-chip
          v-for="group in person.customergroups"
          :key="`${person.full_code}-${group.name}-search`"
          :color="groupColors[group.name]"
          class="ma-2"
          small>
          {{ group.name }}
        </v-chip>
      </template>
    </v-card-title>
    <v-tabs>
      <v-tab>Материалы</v-tab>
      <v-tab>Отчеты</v-tab>
      <v-tab-item
        :key="1">
        <v-list>
          <v-list-item-title v-show="productsTypes.length===0" style="padding-left: 20px">
            Нет данных
          </v-list-item-title>
          <v-list-group
            v-for="(currentProducts, i) in productsTypes"
            v-if="currentProducts && currentProducts.items.length !==0"
            :key="i"
            :value="false">
            <template v-slot:activator>
              <v-list-item-title>{{ currentProducts.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(product, j) in currentProducts.items"
              :key="j"
              link>
              <v-list-item-title>{{ product.name }}</v-list-item-title>
              {{ product.amount }}
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-tab-item>
      <v-tab-item
        :key="2">
        <v-list>
          <template v-for="(report, i) in reports">
            <v-list-group
              :key="i"
              :value="false"
              :disabled=" report && report.productsData ? report.productsData.filter(v=>v.amount>0).length===0 : false"
              :class="{'is-disabled':report && report.productsData ? report.productsData.filter(v=>v.amount>0).length===0 : null}"
              :append-icon="report && report.productsData ? report.productsData.filter(v=>v.amount>0).length===0 ? null :'mdi-chevron-down':null">
              <template v-slot:activator>
                <v-list-item-title :disabled="report && report.productsData ? report.productsData.filter(v=>v.amount>0).length===0 : false">
                  <v-chip
                    class="ma-2"
                    label>
                    {{ formatDate(report.date) }}
                  </v-chip>
                  {{ report.place }}
                </v-list-item-title>
                <v-list-item-action>
                  <v-btn @click="edit(report.id, report.type)" class="edit">
                    <span class="d-none d-sm-flex">Просмотреть</span>
                    <v-icon class="d-flex d-sm-none">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
              <template v-if="report && report.productsData">
                <v-list-item
                  v-for="(product, j) in report.productsData"
                  v-if="product.amount>0"
                  :key="j"
                  link>
                  <template>
                    <v-list-item-title>{{ product.product.name }}</v-list-item-title>
                    {{ product.amount }}
                  </template>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>

// import {mapState} from 'vuex'

export default {
  name: "PersonDetailed",
  props: {
    person: {
      type: Object,
      default: () => {
      }
    },
    products: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      groupColors: {'СР': 'pink', 'ЛУН': 'green', 'МСМ': 'blue'}
    }
  },
  computed: {
    // ...mapState({
    //   products: state => state.tableData.products
    // }),

    productsTypes () {
      if (this.person.products.filter(v => v.amount != 0).length === 0) return []
      const types =
          {
            'Материалы': {
              id: 2,
              name: "Материалы",
              'items': []
            },
            "Консультации": {
              id: 2,
              name: "Консультации",
              items: []
            },
            "Направления": {
              id: 3,
              name: "Направления",
              items: []
            }, "Налоксон": {
              id: 4,
              name: "Налоксон",
              items: []
            }, "Тесты": {
              id: 5,
              name: "Тесты",
              items: []
            }
          }
      this.person.products.forEach((item, i) => {
        if (item.amount !== 0 && item.name !== 'Налоксон') {
          const index = types['Материалы'].items.findIndex(existingItem => existingItem.product === item.product)
          item['name'] = item.product ? item.product.name : ''

          if (index === -1) {

            types['Материалы'].items.push(item)
          } else {
            types['Материалы'].items[index].amount = parseInt(item.amount) + parseInt(types['Материалы'].items[index].amount)
          }
        } else if (item.name === 'Налоксон') {
          const index = types['Налоксон'].items.findIndex(existingItem => existingItem.product === item.product)
          if (index === -1) {
            types['Налоксон'].items.push(item)
          } else {
            types['Налоксон'].items[index].amount = parseInt(item.amount) + parseInt(types['Налоксон'].items[index].amount)
          }
        }
      })
      if (this.person.consultations) {
         this.person.consultations.forEach((item, i) => {
          const index = types['Консультации'].items.findIndex(existingItem => existingItem.consultations_id === item.consultations_id)
        //console.log('cons', item)
        item['name'] = item.consultation ? item.consultation.name : ''
            item['amount'] = 1
          if (index === -1) {

            types['Консультации'].items.push(item)
          } else {
            types['Консультации'].items[index].amount = 1 + parseInt(types['Консультации'].items[index].amount)
          }
      })
      }
      if (this.person.directions) {
         this.person.directions.forEach((item, i) => {
          const index = types['Направления'].items.findIndex(existingItem => existingItem.directions_id === item.directions_id)
                item['name'] = item.direction ? item.direction.name : ''
            item['amount'] = 1

          if (index === -1) {

            types['Направления'].items.push(item)
          } else {
            types['Направления'].items[index].amount = 1 + parseInt(types['Направления'].items[index].amount)
          }
      })
      }
      if (this.person.tests) {
              this.person.tests.forEach((item, i) => {
          const index = types['Тесты'].items.findIndex(existingItem => existingItem.tests_id === item.tests_id)
          item['name'] = item.test.name
          item['amount'] = 1
          if (index === -1) {
            types['Тесты'].items.push(item)
          } else {
            types['Тесты'].items[index].amount = 1 + parseInt(types['Тесты'].items[index].amount)
          }
      })
      }

      return types
    },
    reports () {
      // let vm = this
      // this.person.reports.forEach((report, i) => {
      //   report.reportProducts = vm.person.products.filter(product => {
      //     return product.report === report.report.id
      //   })
      // })

      let vm= this
      if (this.person.reports) {
          this.person.reports.forEach(v => {
        v['productsData'] = vm.person.products.filter(p => p.reports_id === v.id)
        v['consultsData'] = vm.person.consultations.filter(p => p.reports_id === v.id)
        v['directionsData'] = vm.person.directions.filter(p => p.reports_id === v.id)
        v['testsData'] = vm.person.tests.filter(p => p.reports_id === v.id)
      })
      }

      return this.person.reports
    }
  },
  methods: {
    edit (id, type) {
      // router.push({ path: 'register', query: { plan: 'private' } })
      let route = 'ReportOutreachList'
      switch (type) {
        case "outreaches":
          route = 'ReportOutreachList'
          break
        case "seminars":
          route = 'ReportSeminarsUpdate'
          break
        case "casemanagements":
          route = 'ReportCaseList'
          break
        case "psychologists":
          route = 'ReportPsychologistsUpdate'
          break
        case "lawyers":
          route = 'ReportLawyersUpdate'
          break
        case "lgbtqcommunities":
          route = 'ReportLGBTQUpdate'
          break
        default:
          route = 'ReportOutreachList'
      }

      this.$router.push({name: route, params: {reportId: id}})
    },

    getProductType (id) {
      const product = this.products.find(product => id === product.id)
      return product.producttype.id
    },
    getProductName (id) {
      const product = this.products.find(product => id === product.id)
      return product ? product.name : ''
    },
    formatDate (date) {
      const [year, month, day] = date.split('-')
      if (this.pickerType === 'month')
        return `${month}.${year}`
      return `${day}.${month}.${year}`
    }
  }
}
</script>

<style scoped lang="scss">
div.is-disabled {
  & > i {
    display: none !important;
  }
}

.edit {
  margin-right: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportPerPerson/PersonDetailed.vue